export default __webpack_public_path__ + "static/media/facebook-icon.1d5785a4.svg";